import { request } from '@/api/request'
import GlobalConfig from '@/global/config'

const checkResponse = res => {
  return new Promise((resolve, reject) => {
    if (res.status >= 200 && res.status < 300) {
      resolve(res.data)
    }
    reject(res.data)
  })
}
// 购入短信
export function buyTextMsgInCompany(companyId, total) {
  return request({
    url: `/api/captialMessage/purchase?companyId=${companyId}&total=${total}&token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'post'
  }).then(checkResponse)
}

// 微信充值
export function weChatCharge(fee, companyId) {
  return request({
    url: `/api/transaction/weixin/recharge?fee=${fee}&companyId=${companyId}&token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'post'
  }).then(checkResponse)
}

// 监听微信充值状态
export function getWeChatChargeStatus(innerId) {
  return request({
    url: `/api/transaction/bind/recharge?innerId=${innerId}&token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get'
  }).then(checkResponse)
}
